// images @ ui/src/components/static/

import React, { Component } from 'react'
import './home.css';  // react href ID over jump settings

function importAll(r) {
  let images = {};
  r.keys().map((item, index) => { images[item.replace('./', '')] = r(item); });
  return images;
}
const images = importAll(require.context('./static', false));
// ui/src/components/static
//console.log('images:', images)


export default class Help extends Component {
  constructor(props) {
    super(props)
    this.topFunction = this.topFunction.bind(this);
    this.pdfReport = this.pdfReport.bind(this);
  }

  topFunction() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }

  pdfReport() {
    // Do computation here to generate list
    return ("PDF report download");
  }


  render() {
    //console.log('images: ', images)

    return (
      <section className="mx-5" style={{ maxWidth: "100%" }} >

        {/* <img src={images['user-guide-icon.svg']} width="48" height="48" alt="guide-image" /> */}
        <p id="FSV Usage" className="title is-6">~~~ FiveStar Vocab Quick start guide ~~~</p>      
        <p >for teacher and student users</p>
        <a href="#chapter1">1 The simplest way to try out this tool</a> <br />
        <a href="#chapter2">2 Signup options</a> <br />
        <a href="#chapter3">3 The user learning levels vs FS options </a> <br /><br></br>

        <p >for teacher users</p>
        <a href="#chapter4">4 Classes menu and submenus</a> <br />
        <a href="#chapter5">5 How to open textbook(s) and assign tasks</a> <br />

        <p >other useful docs and audio files</p>
        <a href="#chapter6">6 FAQ (frequently asked questions)</a> <br />
        <a href="#chapter7">7 Web mobile display special notes</a> <br />
        <a href="/padocs" target="_blank"><u>8 Links to guide demos and docs</u></a>
        <br /><br />

        <p id="chapter1" className="title is-6">1 Quick Start Guide</p>
        <p>To test the tool immediately, use the preset usernames <b>demot</b> (English flashcards), <b>demotcn</b> (Simplified Chinese), or <b>demottw</b> (Traditional Chinese). The password for each is the same as the username.</p>
        <p>The emails and passwords to check the PDF report files are <b>pareport@126.com</b> and <b>Pareport126</b>. </p> 
        <br></br>
        
        <p id="chapter2" className="title is-6">2 Signup Requirements</p>
        <p>When signing up, please note that fields outlined in <span style={{backgroundColor: 'red'}}>red</span> are mandatory. The "Flashcard translation language" defaults to English. If you select "Simplified Chinese," you may register as either a teacher or a student; all other language selections are restricted to teacher accounts.</p><br></br>

        <img src={images['signup-default.png']} alt="signup-default-image" />

        <img src={images['signup-demot.png']} alt="signup-image" />
        <p>Signup as teacher demot, and the defalut Flashcard translation language is English.</p> <br></br>
        <img src={images['signup-simplified-Chinese.png']} alt="signup-simplified-Chinese-image" />
        <button className="button is-small is-success is-pulled-right" onClick={this.topFunction}>
          Back-to-top
        </button><br></br><br></br>

        <p id="chapter3" className="title is-6">3 The user learning levels vs FS options</p>
        <img src={images['level.png']} alt="level-image" /> <br></br><br></br>
        <p>Note the welcome message at the top-right corner of above screenshot, demotcn is the user, the stars show the user's current learning level to the selected textbooks: ✫ for beginner, ✫✫ for middle, and ✫✫✫ for advanced. </p> 
        <br></br>
        <p> The FS flashcards have three options to match with the user levels. For the beginner level, the FS word will be shown in English plus the selected flashcard translation language, as shown in below screenshot for simplified-Chinese user. </p>
        <br></br>
        <img src={images['FS-level-low.png']} alt="FS-level-low-image" /> <br></br><br></br>
        <p> For the middle level, the FS word will be shown in English only. </p>
        <p> For the advanced level, only the first letter of the FS word will be shown. </p>
        <p> In the FS word definitions section, symbol ~ can be used to represent the word in topic. </p>
        <p> The word spell for both FS and SB is case-insensitive to make typing easier. </p><br></br>

        <p id="chapter4" className="title is-6">4 Classes menu and submenus</p>
        <p>Only available for simplified-Chinese users.</p>
        <span className="has-text-weight-bold">4.1 +Class submenu</span>
        <p>There is no class exist when a teacher first time login, press +Class to add a class as below.</p> <br></br>
        <img src={images['+class.png']} alt="class-image" /> <br></br><br></br>
        <p>Special notes to +Class:</p>
        <p>1. schoolID: ES(Elementary School), MS(Middle School), HS(High School)</p>
        <p>2. pressID: textbook press ID, such as PEP, RJB(People's Education Press), BNU (Beijing Normal University) etc</p>
        <p>3. schoolID must be selected before pressID</p>
        <br></br>

        <span className="has-text-weight-bold">4.2 selectClass submenu</span>
        <p>One of the classes must be selected to work with at one time, below is an example, and pay attention to the welcome message before & after the select. </p>
        <img src={images['selectClass.png']} width="600" height="276" alt="class-image" /> <br></br>
        <img src={images['selectClass-1.png']} width="600" height="195" alt="class-image" /> <br></br><br></br>
        <button className="button is-small is-success is-pulled-right" onClick={this.topFunction}>
          Back-to-top
        </button>

        <p id="chapter5" className="title is-6">5 How to open textbook(s) and assign tasks</p>
        <p>Below screenshot shows how to open textbooks for "Elementary school-PEP".</p> 
        <img src={images['standards.png']} width="648" height="314" alt="standards-image" /> <br></br><br></br>

        <p>Below picture shows adding the 2nd unit of book "4A 2013" to the tasks.</p> <br></br>
        <img src={images['textbooks.png']} width="555" height="439" alt="textbooks-image" /> <br></br><br></br>

        <p id="chapter6" className="title is-6">6 FAQ (frequently asked questions)</p>
        <p style={{color: 'green'}}>1. I'll signup as a student user, what is the process to use this tool?</p> 
        <p>The student process is simple as follows: </p> 
        <p>1) ask your teacher to get the teachername & classname; </p> 
        <p>2) signup with the teachername & classname, and your username will be automatically added to the classname;</p> 
        <p>3) sign in to check & do your tasks your teacher assigned; </p> 
        <p>4) The task report you've done will be automatically sent to you and your teachers' email boxes. </p> <br></br>

        <p style={{color: 'green'}}>2. I'll signup as a teacher user, what is the process to use this tool?</p> 
        <p>The teacher process briefs like these: </p> 
        <p>1) signup as teacher;</p> 
        <p>2) login; </p> 
        <p>3) click +Class to add a class, then give the teachername & classname to your students to let them sign up to this classname; </p> 
        <p>4) click SelectClass to select this class to work with; </p>
        <p>5) click Textbooks to add tasks to this class; </p>
        <p>6) you'll automatically receive the task reports when students finished, also you can go click Report submenu to view and download them. </p><br></br>

        <p style={{color: 'green'}}>3. I'm a student, can I use this tool just by myself?</p> 
        <p>Sure you can. Just follow the teacher's process as above.</p> <br></br>

        <p style={{color: 'green'}}>4. what is a base word and how it's used in SpellingBee?</p> 
        <p>A base word is the core of a word that contains its essential meaning, and it can have different variable words. For example, "good" is a base word, while "better" and "best" are just it's variable forms.</p>
        <p>The base word of "apples" is "apple".</p>
        <p>The base word of "takes", "took", "taking", or "taken" is "take".</p><br></br>

        <p>The SpellingBee will speak a word or two-words phrase, a sentence and the word again. Then you are prompted to input the word. The sentence may not contain the exact word, but a variable form word of the base word.</p> <br></br>

        <p style={{color: 'green'}}>5. Why occasionally I felt the response is slow during the 1st time use?</p>
        <p>During the 1st time use, the system will setup a database for each user, and it takes extra time than usual. If your internet speed is not high enough, you could notice the slow response time. </p> <br></br>

        <p style={{color: 'green'}}>6. The audio does not immediately play after hitting the play icon of the SB?</p>
        <p>If the audio does not play immediately after clicking the play icon, your device may be experiencing network interference. Ensure the icon switches to the "pause" state after being pressed to confirm the data request is active.</p><br></br>

        <button className="button is-small is-success is-pulled-right" onClick={this.topFunction}>
          Back-to-top
        </button>


        <p id="chapter7" className="title is-6">7 Web mobile display special notes</p>
        <p>1. Mobile uses "burger menu", which is a three-stacked-line icon at the right-top corner as below.</p>
        <img src={images['8-burger-menu-off.png']} width="449" height="79" alt="8-burger-menu-off.png" />
        <br />
        <br />
        <p>Click the burger menu to display all the menus, then click your selected menu such as "Login" to access it. And the the burger menu will automatically revert to the original icon.</p>
        <br />
        <img src={images['9-burger-menu-on.png']} width="431" height="220" alt="9-burger-menu-on.png" />
        <br />
        <p>If you clicked the burger menu just to check, then you need press the "x" icon to back to the burger menu icon.</p> <br />

        <p>2. It is recommended to enable 'Auto-rotate screen' on your mobile device.</p>
        <p>For the Android mobile, Settings / Display / Advanced / Auto-rotate screen: on</p>
        <br />

        <p>3. Mobile portrait and landscape may have different content, such as below example  for the same task page.</p>
        <br />
        <img src={images['10-mobile-task-portrait.png']} width="362" height="239" alt="10-mobile-task-portrait.png" />
        <p>Task page at mobile portrait orientation</p>
        <br></br>
        <img src={images['11-mobile-task-landscape.png']} width="478" height="201" alt="11-mobile-task-landscape.png" />
        <p>Task page at mobile landscape orientation</p>
        <br></br>
        <button className="button is-small is-success is-pulled-right" onClick={this.topFunction}>
          Back-to-top
        </button>
        <br></br><br></br>
      </section>
    );
  }
}